exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Container-module__container___3CARo{padding:2.5rem 1.25rem 0;margin-bottom:2.5rem;width:100%;height:auto}@media screen and (min-width:1024px){.Container-module__container___3CARo{padding:2.5rem 2.5rem 0;margin-bottom:2.5rem}}", ""]);

// exports
exports.locals = {
	"container": "Container-module__container___3CARo"
};